import { render, staticRenderFns } from "./OutputSampleSize.vue?vue&type=template&id=2b860132"
import script from "./OutputSampleSize.vue?vue&type=script&lang=js"
export * from "./OutputSampleSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports